import { render, staticRenderFns } from "./TwitterPreview.vue?vue&type=template&id=2e4a2da0&scoped=true&"
import script from "./TwitterPreview.vue?vue&type=script&lang=ts&"
export * from "./TwitterPreview.vue?vue&type=script&lang=ts&"
import style0 from "./TwitterPreview.vue?vue&type=style&index=0&id=2e4a2da0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a2da0",
  null
  
)

export default component.exports